import { InputBasic } from './InputBasic';
import { InputControlled } from './InputControlled';
import { InputPassword } from './InputPassword';
import { InputPrice } from './InputPrice';
export { useInput } from './useInput';

export const Input = {
  Controlled: InputControlled,
  Basic: InputBasic,
  Password: InputPassword,
  Price: InputPrice,
};
